import { fetchGroups } from '../fetch/documents';
import { createReducer } from './createReducer';
const groupsSlice = createReducer("groups", fetchGroups);


export const selectGroups = (state) => state.groups.value
export const selectLoadingGroups = (state) => state.groups.isLoading

export const {} = groupsSlice.actions

export default groupsSlice.reducer

